import { get } from 'helpers/api';

import { getRequestReference } from 'helpers/axios';
import RansackQuery from 'helpers/ransack_query';
import debounceActionCreators from 'helpers/redux/debounce_action_creators';
import { snakeCase } from 'lodash';

const debouncedActionCreators = debounceActionCreators({ retrieveRecords }, 1000);

const keys = {
  assignmentType: 'q[with_assignment_types]',
  broker: 'q[with_user_ids]',
  propertyType: 'q[asset_type_in]',
  status: 'q[tenant_rep_listing_status_in]',
  searchText: 'q[title_or_address_cont]'
};

export const SET_RECORDS = 'SET_RECORDS';
function setRecords(records) {
  return { ...records, type: SET_RECORDS };
}

export const RETRIEVE_RECORDS_STARTED = 'RETRIEVE_RECORDS_STARTED';
function retrieveRecordsStarted(requestReference) {
  return { requestReference, type: RETRIEVE_RECORDS_STARTED };
}

export function retrieveRecords() {
  return (dispatch, getState) => {
    const { paths, query, search } = getState();

    if (search.requestReference) search.requestReference.cancel();

    const requestReference = getRequestReference();
    const ransackQuery = filterOptionsAsQueryParameter(query);

    dispatch(retrieveRecordsStarted(requestReference));

    get(paths.assignments, {
      cancelToken: requestReference.token,
      params: { ...ransackQuery, page: query.page }
    }).then((records) => {
      dispatch(setRecords(records));
    });
  };
}

export function delayRetrieveRecords() {
  return (dispatch) => {
    dispatch(retrieveRecordsStarted());
    return debouncedActionCreators.retrieveRecords(dispatch);
  };
}

export function filterOptionsAsQueryParameter(query) {
  const filterOptions = retrieveFilterOptions(query);

  return (new RansackQuery(filterOptions, keys).toRansack());
}

function retrieveFilterOptions(query) {
  const filterOptions = {
    assignmentType: query.assignmentTypeFilter,
    broker: query.brokerFilter,
    propertyType: query.propertyTypeFilter,
    searchText: query.searchText,
    status: query.statusFilter
  };

  filterOptions.status = query.statusFilter.map(status => snakeCase(status));

  return filterOptions;
}
